// Offline policy: cached reads are permitted, but queued business mutations are never replayed.
// Legacy pending actions are retained for explicit human reconciliation.
import { getPendingActions } from './db';

export const startSyncService = () => {
  const reviewLegacyActions = () => { void syncPendingActions(); };
  window.addEventListener('online', reviewLegacyActions);
  reviewLegacyActions();
  return () => window.removeEventListener('online', reviewLegacyActions);
};

export const syncPendingActions = async () => {
  const pending = await getPendingActions();
  pending.forEach(action => window.dispatchEvent(new CustomEvent('offline-sync-attention', {
    detail: { ...action, quarantineReason: 'Offline mutation replay is disabled. Verify the business record before manually re-entering.' }
  })));
  return { synced: 0, remaining: pending.length, quarantined: pending.length };
};

export const isOnline = () => navigator.onLine;
export const onOnline = callback => {
  window.addEventListener('online', callback);
  return () => window.removeEventListener('online', callback);
};
export const onOffline = callback => {
  window.addEventListener('offline', callback);
  return () => window.removeEventListener('offline', callback);
};
